/**
 * Rooms Service
 * Handles room management operations
 * One module for one supabase service - following the app's architecture rule
 */

import { supabaseAdmin as supabase } from '../lib/supabase.js';

class RoomsService {
  /**
   * Get all rooms for a specific tenant
   * @param {string} tenantId - Tenant ID
   * @returns {Promise<Array>} Array of rooms
   */
  async getAllRooms(tenantId) {
    try {
      if (!tenantId) {
        throw new Error('tenantId is required for getAllRooms');
      }

      // For now, return a default list of common rooms
      // In the future, this could be stored in a rooms table
      const defaultRooms = [
        '101', '102', '103', '104', '105', '106', '107', '108', '109', '110',
        '111', '112', '113', '114', '115', '116', '117', '118', '119', '120',
        '201', '202', '203', '204', '205', '206', '207', '208', '209', '210',
        '211', '212', '213', '214', '215', '216', '217', '218', '219', '220',
        '301', '302', '303', '304', '305', '306', '307', '308', '309', '310',
        '311', '312', '313', '314', '315', '316', '317', '318', '319', '320',
        '401', '402', '403', '404', '405', '406', '407', '408', '409', '410',
        '411', '412', '413', '414', '415', '416', '417', '418', '419', '420',
        '501', '502', '503', '504', '505', '506', '507', '508', '509', '510',
        '511', '512', '513', '514', '515', '516', '517', '518', '519', '520',
        '601', '602', '603', '604', '605', '606', '607', '608', '609', '610',
        '611', '612', '613', '614', '615', '616', '617', '618', '619', '620',
        'G01', 'G02', 'G03', 'G04', 'G05', 'G06', 'G07', 'G08', 'G09', 'G10',
        'Hall', 'Library', 'Lab1', 'Lab2', 'Lab3', 'Computer Lab', 'Music Room', 'Art Room', 'Gym'
      ];

      return defaultRooms.map(room => ({
        id: room,
        name: room,
        code: room
      }));
    } catch (error) {
      console.error('Error fetching rooms:', error);
      throw error;
    }
  }

  /**
   * Search rooms by name or code
   * @param {string} tenantId - Tenant ID
   * @param {string} searchTerm - Search term
   * @returns {Promise<Array>} Array of matching rooms
   */
  async searchRooms(tenantId, searchTerm) {
    try {
      const allRooms = await this.getAllRooms(tenantId);
      const filtered = allRooms.filter(room => 
        room.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        room.code.toLowerCase().includes(searchTerm.toLowerCase())
      );
      return filtered;
    } catch (error) {
      console.error('Error searching rooms:', error);
      throw error;
    }
  }
}

export default new RoomsService();
